import useFetchObjects from "../../api/useFetchObjects";

const useAudioBookList = (filters, sort, page) => {
  const queryParams = new URLSearchParams();

  // Add filters
  if (filters.format) queryParams.append("format", filters.format);
  if (filters.category) queryParams.append("category", filters.category);
  if (filters.minPrice) queryParams.append("min_price", filters.minPrice);
  if (filters.maxPrice) queryParams.append("max_price", filters.maxPrice);
  if (filters.search) queryParams.append("search", filters.search);

  // Add sorting - Change 'sort' to 'ordering' to match DRF's parameter
  if (sort) queryParams.append("ordering", sort);

  // Add pagination
  queryParams.append("page", page);
  queryParams.append("page_size", "12");

  // Get token from localStorage
  const token = localStorage.getItem("token");

  return useFetchObjects(
    ["books_audio", filters, sort, page],
    `books/audio_books/?${queryParams.toString()}`,
    token ? token : null,
    {
      refetchOnWindowFocus: false,
    },
  );
};

export default useAudioBookList;
